/**
 * Maps tRPC / Zod validation text to a single friendly line for customer save flows.
 * Avoids exposing raw `path: ["name"]` / `too_small` details to end users.
 */
export function mapCustomerUpdateErrorMessage(message: string): string {
  if (
    message.includes("Please enter customer name before saving") ||
    (/\btoo_small\b/i.test(message) && /\bname\b/i.test(message)) ||
    /path:?\s*\[.*["']name["'].*\]/i.test(message) ||
    /\["name"\].*expected/i.test(message)
  ) {
    return "Please enter customer name before saving.";
  }
  return message;
}
